import React, { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom"
import axios from "axios"
import { fetchAllBusiness } from "../actions/businessAction"
import { format, formatDate } from "../main"
import SideNav from "../components/SideNav"
import { Helmet } from "react-helmet"
import Header from "../components/Header"
import DatePicker from "react-datepicker"
import Loader from "../components/Loader"
import { MDBTable, MDBTableBody, MDBTableHead } from "mdb-react-ui-kit"
import moment from "moment"
import Paginate from "../components/Paginate"
import { BASE_API_URL } from "../constants/dropdown"

const BusinessScreen = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const businessRef = useRef(true)
  const [currPage, setCurrPage] = useState(1)
  const [businessemail, setBusinessemail] = useState("")
  const [accountnumber, setAccountnumber] = useState("")
  const year = new Date().getFullYear()
  const [startDate, setStartDate] = useState(new Date(year, 0, 1))
  const [endDate, setEndDate] = useState(new Date())
  const [isOpen2, setIsOpen2] = useState(false)
  const [customerId, setCustomerId] = useState("")
  const [transactionReference, setTransactionReference] = useState("")
  const [paymentReference, setPaymentReference] = useState("")
  const [styles, setStyles] = useState({
    navContainer: {
      display: "none"
    }
  })
  const [exportLoading, setExportLoading] = useState(false)

  const admin2faLogin = useSelector((state) => state.admin2faLogin)
  const { userInfo } = admin2faLogin

  const getAllBusiness = useSelector((state) => state.getAllBusiness)
  const { loading, success, business, error } = getAllBusiness

  useEffect(() => {
    if (businessRef.current) {
      dispatch(fetchAllBusiness())
      businessRef.current = false
    }
    if (userInfo?.user?.role === "Account Officer") {
      navigate("/performance", { replace: true })
    }
  })

  const afterPageClicked = (page_number) => {
    if (page_number === "undefined1") {
      setCurrPage(1)
      dispatch(fetchAllBusiness(1, { startDate: formatDate(startDate), endDate: formatDate(endDate), businessemail, accountnumber }))
      return
    }

    const nextPage = page_number === currPage ? page_number + 1 : page_number
    setCurrPage(nextPage)

    const filterData = {
      startDate: formatDate(startDate),
      endDate: formatDate(endDate),
      businessemail,
      accountnumber
    }
    dispatch(fetchAllBusiness(nextPage, filterData))
  }

  const handleDownloadCSV = async () => {
    setExportLoading(true)
    try {
      const token = userInfo?.token?.access_token
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/business/all?page=1&size=10000`,
        { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } }
      )
      const items = data?.items || []
      const escape = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`
      const csvHeaders = [
        "Business Name", "Registration Number", "Support Email", "Support Mobile",
        "Number of Employees", "Address", "City", "State", "Country", "Merchant Tag",
        "LGA", "Incorporation Date", "Wallet Balance", "Transaction Count",
        "Account Numbers", "Merchant Banks", "Account Count", "Date Created"
      ]
      const rows = items.map((b) => [
        b.business_name, b.registration_number, b.support_email_address, b.support_mobile_number,
        b.number_of_employee, b.address, b.city, b.state, b.country, b.merchant_tag,
        b.lga, b.incoporation_date, b.wallet_balance, b.transaction_count,
        b.merchant_account_numbers, b.merchant_banks, b.account_count, b.date_created
      ].map(escape).join(","))
      const csv = [csvHeaders.map(escape).join(","), ...rows].join("\n")
      const blob = new Blob([csv], { type: "text/csv" })
      const url = URL.createObjectURL(blob)
      const a = document.createElement("a")
      a.href = url
      a.download = "all-businesses.csv"
      a.click()
      URL.revokeObjectURL(url)
    } catch (e) {
      console.error(e)
    }
    setExportLoading(false)
  }

  const handleClick = () => {
    if (styles.navContainer.display === "block") {
      setStyles({
        navContainer: {
          display: "none"
        }
      })
    } else {
      setStyles({
        navContainer: {
          display: "block"
        }
      })
    }
  }

  const handleFilter = () => {
    setStyles({
      navContainer: {
        display: "none"
      }
    })
    const filterData = {
      startDate: formatDate(startDate),
      endDate: formatDate(endDate),
      businessemail,
      accountnumber
    }

    console.log(filterData)

    dispatch(fetchAllBusiness(currPage, filterData))
  }

  const handleClear = () => {
    setBusinessemail("")
    setAccountnumber("")
    setStyles({
      navContainer: {
        display: "none"
      }
    })

    dispatch(fetchAllBusiness())
  }

  return (
    <>
      <SideNav />
      <Helmet>
        <title>Customer | PennyTree - All Business</title>
      </Helmet>
      <section className="page-container">
        <div className="page-content">
          <Header />
          <div className="page-body">
            <h1>All Businesses</h1>
            <div className="filter-box">
              <div className="filter" onClick={handleDownloadCSV} style={{ cursor: "pointer", color: "white" }}>
                {exportLoading ? "Exporting..." : "Export All"}
              </div>
              <div className="filter">
                <>
                  <div className="filter-container">
                    <p style={{ cursor: "pointer", color: "white" }} onClick={handleClick}>
                      Filter
                    </p>
                    <div className="navContainer" style={styles.navContainer}>
                      <div
                        className="date-filter"
                        style={{
                          display:
                            transactionReference || paymentReference
                              ? "none"
                              : "block"
                        }}
                      >
                        <div className="date-title">Date</div>
                        <div className="date-options">
                          <div className="date-content">
                            <div className="date-items">
                              <DatePicker
                                selected={startDate}
                                onChange={(date) => setStartDate(date)}
                              />

                              <DatePicker
                                selected={endDate}
                                onChange={(date) => setEndDate(date)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="status-container">
                        <div className="date-title">Other Filters</div>
                        <div className="checkbox checkbox--flex">
                          <div
                            className="checkbox__item"
                            style={{
                              width: "100%"
                            }}
                          >
                            <input
                              style={{
                                width: "100%",
                                borderRadius: "10px",
                                border: "1px solid grey",
                                fontSize: "14px",
                                display: paymentReference ? "none" : "block"
                              }}
                              type="email"
                              className="email-input"
                              value={transactionReference}
                              onChange={(e) =>
                                setTransactionReference(e.target.value)
                              }
                              placeholder="Enter Transaction Reference"
                            />{" "}
                          </div>
                          <div
                            className="checkbox__item"
                            style={{
                              width: "100%"
                            }}
                          >
                            <input
                              style={{
                                width: "100%",
                                borderRadius: "10px",
                                border: "1px solid grey",
                                fontSize: "14px",
                                display: transactionReference ? "none" : "block"
                              }}
                              type="email"
                              className="email-input"
                              value={paymentReference}
                              onChange={(e) =>
                                setPaymentReference(e.target.value)
                              }
                              placeholder="Enter Payment Reference"
                            />{" "}
                          </div>
                        </div>
                      </div>
                      <div
                        className="status-container"
                        style={{
                          display: "flex",
                          justifyContent: "space-evenly",
                          alignItems: "center"
                        }}
                      >
                        <button className="button" onClick={handleClear}>
                          <p>Clear</p>
                        </button>
                        <button className="button" onClick={handleFilter}>
                          <p>Filter</p>
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              </div>
            </div>
            {loading ? (
              <Loader></Loader>
            ) : error ? (
              <p>{error}</p>
            ) : (
              <>
                <MDBTable responsive>
                  <MDBTableHead>
                    <tr className="font-reduce">
                      <th scope="col">S/N</th>
                      <th scope="col">Business Name</th>
                      <th scope="col">Registration Number</th>
                      <th scope="col">Support Email</th>
                      <th scope="col">Support Mobile</th>
                      {/* <th scope="col">Status ID</th> */}
                      <th scope="col">Number of Employees</th>
                      <th scope="col">Address</th>
                      <th scope="col">City</th>
                      <th scope="col">State</th>
                      <th scope="col">Country</th>
                      <th scope="col">Merchant Tag</th>
                      <th scope="col">LGA</th>
                      <th scope="col">Incorporation Date</th>
                      <th scope="col">Wallet Balance</th>
                      <th scope="col">Transaction Count</th>
                      {/* <th scope="col">Wallet ID</th> */}
                      <th scope="col">Account Numbers</th>
                      <th scope="col">Merchant Banks</th>
                      <th scope="col">Account Count</th>
                      <th scope="col">Date Created</th>
                      <th scope="col"></th>
                      <th scope="col"></th>
                    </tr>
                  </MDBTableHead>
                  <MDBTableBody>
                    {success &&
                      business?.items?.length > 0 &&
                      business?.items?.map((merchant, key) => (
                        <tr key={key} className="font-reduce">
                          <td>
                            {key + 1 + (business?.page?.total_skipped || 0)}
                          </td>
                          <td style={{ "width": "100%" }}>
                            <a
                              href={`/merchant/${merchant?.id}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {merchant?.business_name}
                            </a>
                          </td>
                          <td>{merchant?.registration_number}</td>
                          <td>
                            <a
                              href={`mailto:${merchant?.support_email_address}`}
                            >
                              {merchant?.support_email_address}
                            </a>
                          </td>
                          <td>{merchant?.support_mobile_number}</td>
                          {/* <td>
                            <span
                              className={`badge ${
                                merchant?.status_id === 1
                                  ? "bg-success"
                                  : "bg-warning"
                              }`}
                            >
                              {merchant?.status_id === 1
                                ? "Active"
                                : "Inactive"}
                            </span>
                          </td> */}
                          <td>{merchant?.number_of_employee}</td>
                          <td>
                            {merchant?.address?.substring(0, 20)}
                            {merchant?.address?.length > 20 ? "..." : ""}
                          </td>
                          <td>{merchant?.city}</td>
                          <td>{merchant?.state}</td>
                          <td>{merchant?.country}</td>
                          <td>
                            <span className="badge bg-primary">
                              {merchant?.merchant_tag}
                            </span>
                          </td>
                          <td>{merchant?.lga}</td>
                          <td>
                            {moment(merchant?.incoporation_date).format("LL")}
                          </td>
                          <td>
                            <span
                              className={`fw-bold ${
                                merchant?.wallet_balance > 0
                                  ? "text-success"
                                  : "text-muted"
                              }`}
                            >
                              {format(merchant?.wallet_balance)}
                            </span>
                          </td>
                          <td>
                            <span className="badge bg-info">
                              {merchant?.transaction_count}
                            </span>
                          </td>
                          {/* <td>{merchant?.wallet_id || "---"}</td> */}
                          <td>{merchant?.merchant_account_numbers || "---"}</td>
                          <td>{merchant?.merchant_banks || "---"}</td>
                          <td>{merchant?.account_count}</td>
                          <td>
                            {moment(merchant?.date_created).format("LLL")}
                          </td>
                          <td>
                            {/* <a href={`/business/details`}>View Details</a> */}

                            <button className="withdrawal-btn">
                              <Link
                                to={`/business/details`}
                                state={{
                                  walletid: merchant?.wallet_id,
                                  customerid: merchant?.customer_id,
                                  businessName: merchant?.business_name,
                                  businessid: merchant?.id
                                }}
                              >
                                View Details
                              </Link>
                            </button>
                          </td>
                        </tr>
                      ))}
                  </MDBTableBody>
                </MDBTable>

                <Paginate
                  totPages={Math.ceil((business?.page?.total || 0) / (business?.page?.size || 50))}
                  currentPage={String(business?.page?.current_page)}
                  page={String(business?.page?.current_page)}
                  pageClicked={(ele) => {
                    afterPageClicked(ele)
                  }}
                />
              </>
            )}
          </div>
        </div>
      </section>
    </>
  )
}

export default BusinessScreen
